import React from "react";
import PropTypes from "prop-types";
import * as NotificationSapService from "../../../../services/NotificationSapService";
import { useTranslation } from "react-i18next";
import NotificationSapFormView from "./notificationSapForm.view";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";

const NotificationSapCreateFormContainer = ({
  productionOrderSapUuid,
  type,
  onCancel,
  onSuccess,
}) => {
  const { t } = useTranslation();

  const handleSubmit = async (values) => {
    try {
      const payload = {
        sapBatch: values.sapBatch,
        sapMaterial: values.sapMaterial,
        sapQuantityEntry: Number(values.sapQuantityEntry),
        type,
      };

      const result = await NotificationSapService.create(
        productionOrderSapUuid,
        payload,
      );

      let title = "";
      let text = "";
      let icon = "";
      if (result !== null) {
        title = t("forms.notificationSap.messages.create.title");
        text = t("forms.notificationSap.messages.create.success");
        icon = "success";
      } else {
        title = "Error";
        text = t("forms.notificationSap.messages.create.error");
        icon = "error";
      }

      ShowDialog(title, text, icon, false, "OK", false, () => {
        if (result !== null && onSuccess) {
          onSuccess();
        }
      });
    } catch (error) {
      ShowDialog(
        "Error",
        t("forms.notificationSap.messages.create.error"),
        "error",
        false,
        "OK",
      );
    }
  };

  const title =
    type === 0
      ? t("forms.notificationSap.titleCreateConsumption")
      : t("forms.notificationSap.titleCreateProduction");

  return (
    <NotificationSapFormView
      showMaterial
      title={title}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};

NotificationSapCreateFormContainer.propTypes = {
  productionOrderSapUuid: PropTypes.string,
  type: PropTypes.number,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default NotificationSapCreateFormContainer;
